/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Percentage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Percentage"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        d="M15.333 13.667a1.667 1.667 0 1 1 0 3.333 1.667 1.667 0 0 1 0-3.333m-.577-5.592a.827.827 0 0 1 1.169 1.169l-6.681 6.681a.827.827 0 0 1-1.169-1.169zM8.666 7a1.667 1.667 0 1 1 0 3.333 1.667 1.667 0 0 1 0-3.333"
      />
      <path
        fill="#0E0E0E"
        d="M20.333 12A8.333 8.333 0 1 0 12 20.333V22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10v-1.667A8.333 8.333 0 0 0 20.333 12"
      />
    </g>
  </svg>
);

export const PercentageIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'percentage-icon'}
      icon={Percentage}
      {...props}
      size={size}
    />
  );
};
